import { css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { Style } from "./Styles";
import { BaseElement } from "./BaseElement";
import { getMediaTypeStringFromMimeType } from "../Media";
import { IMedia } from "../models/Models";
import { litIf } from "./LitUtils";

@customElement("ds-media-list")
export class MediaList extends BaseElement {
    static override styles = [
        Style,
        css`
            :host {
                display: block;
            }

            .media-item {
                min-height: 2em;
                border: 1px solid gray;
            }

            .media-desc {
                display: flex;
                flex-direction: column;
                cursor: pointer;
            }

            .media-desc span {
                margin-top: 0;
            }

            .download-icon {
                width: 2em;
            }
        `,
    ];
    @property({ type: Array }) media?: IMedia[];

    override render() {
        return html` <div class="media-list">
            <table class="media full-width-table">
                ${this.media?.map(
                    (x: IMedia) =>
                        html` <tr class="media-item">
                            <td>
                                <div
                                    class="media-desc"
                                    @click=${() => this._raiseEvent("ds-open-media", { media: x })}
                                >
                                    ${litIf(
                                        !!x.description && x.description.length > 0,
                                        () => html`<span>${x.description}</span>`,
                                        () => html`<span>${x.name ?? ""}</span>`
                                    )}
                                </div>
                            </td>
                            <td>${getMediaTypeStringFromMimeType(x.mimeType)}</td>
                            <td class="download-icon">
                                ${litIf(
                                    x.mimeType !== "application/youtube" &&
                                        x.mimeType !== "application/sketchfab",
                                    () => html`
                                        <sl-icon-button
                                            name="download"
                                            @click=${() =>
                                                this._raiseEvent("ds-download-media", { media: x })}
                                        ></sl-icon-button>
                                    `
                                )}
                            </td>
                        </tr>`
                )}
            </table>
        </div>`;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        "ds-media-list": MediaList;
    }
}
